// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3i-LI","calendarButtons":"ClockData_calendarButtons__3UJn4"};